import { CarWindshieldIcon } from './CarWindshieldIcon';

/**
 * author: Michael Richins
 * id 6E8AA995-39A0-44C4-A0FF-3BC1CA7787DE
 * name car-windshield
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-windshield.svg
 * tags
 * - Automotive 
 */
export const CarFrontGlassIcon = CarWindshieldIcon;
export default CarFrontGlassIcon